var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtrialFibrillation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5274 19.9974C15.6774 17.6074 18.1274 16.9774 20.4874 13.6674C21.6874 11.9874 22.4974 9.17743 21.6274 7.17743C19.7074 2.76743 13.7874 3.09743 12.5374 7.74743C10.8474 3.13743 6.75743 3.25743 4.68743 5.54743C2.63743 7.72743 2.37743 11.4074 4.33743 13.7274C6.42743 16.2574 10.0274 17.0974 11.5874 19.9874",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.72754 12.5172H9.40754L11.3275 10.0771L14.3975 15.0971L16.0675 12.5572L20.9575 12.5172",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtrialFibrillation);
export default __webpack_public_path__ + "static/media/AtrialFibrillation.e8d0acbaad6facece04812c08c5d0ca3.svg";
export { ForwardRef as ReactComponent };